// extracted by mini-css-extract-plugin
export default {"gutter":"20px","md":"(min-width: 768px)","container":"Container-module_container__aGcIa"};